import React from "react";
import { IonIcon, IonItem, IonLabel, IonNote, IonRow, IonText, isPlatform } from "@ionic/react";
import { bookmarkOutline, calendarOutline, personOutline } from "ionicons/icons";
import { Document } from "../../../@types/document";
import { DocumentStatusTag } from "./DocumentStatusTag";

interface ItemListProps {
  document: Document;
}

export const HojaDeCargoItem: React.FC<ItemListProps> = ({ document }) => {
  const { createdAt, id, personal, centroCosto, process, nombreCompleto }: any = document;

  const today = new Date();

  const targetDate = new Date(createdAt);

  const fromDate = targetDate.getTime() - today.getTime();

  const daysBetweenDates: number = Math.ceil(fromDate / (1000 * 60 * 60 * 24));

  return (
    <IonItem
      routerLink={`/app/documentos/hoja-de-cargo/${id}`}
      lines="none"
      class="ion-margin-bottom"
    >
      <IonLabel>
        <IonItem lines="none" color="transparent">
          <IonLabel>
            <h2 className="ion-text-wrap">
              <IonLabel style={{ fontWeight: 600 }}>HC {id} </IonLabel>
            </h2>
          </IonLabel>
          <IonNote slot="end">
            <DocumentStatusTag document={document} />
          </IonNote>
        </IonItem>
        <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
          {process != null ? process.description : "No hay datos"}
        </h2>
        <h4>
          <IonIcon icon={personOutline}></IonIcon>
          <IonText class="ion-padding-start ion-text-wrap">
            {nombreCompleto != null ? nombreCompleto : "No hay datos"}
          </IonText>
        </h4>
        <p>
          <IonIcon icon={calendarOutline}></IonIcon>
          <IonText class="ion-padding-start">Hace: {Math.abs(daysBetweenDates)} días</IonText>

          <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
          <IonText class="ion-padding-start ion-text-wrap">
            {centroCosto != null ? centroCosto.cencos_nombre : "No hay datos"}
          </IonText>
        </p>
      </IonLabel>
    </IonItem>
  );
};
